import create from "zustand";
import { WorkflowStep } from "./types";

type OptInState = {
  step: WorkflowStep;
  setStep: (newStep: WorkflowStep) => void;
  submissionError?: string;
  confirmationError?: string;
  phoneNumber?: string;
  setPhoneNumber: (phoneNumber: string) => void;
  setSubmissionError: (error: string) => void;
  setConfirmationError: (error: string) => void;
  container: {
    width: number;
  };
  setContainer: (width: number) => void;
};

export const useOptInStore = create<OptInState>((set) => ({
  step: WorkflowStep.Initial,
  confirmationError: undefined,
  submissionError: undefined,
  phoneNumber: undefined,
  setStep: (step) => set(() => ({ step })),
  setConfirmationError: (error) => set(() => ({ confirmationError: error })),
  setSubmissionError: (error) => set(() => ({ submissionError: error })),
  container: {
    width: 0,
  },
  setContainer: (width) => set(() => ({ container: { width } })),
  setPhoneNumber: (phoneNumber) => set(() => ({ phoneNumber })),
}));
